import styled from 'styled-components';
import { setTypography, calcPxToRem } from 'utils/styles/mixins';
import { colors, rfs } from 'utils/styles/theme';

export const Layout = styled.div`
  border-top: 1px;
  border-style: solid;
  border-color: ${colors.balticSea10};
  ${rfs(`${calcPxToRem(190)}rem`, `padding-top`)}
  ${rfs(`${calcPxToRem(190)}rem`, `padding-bottom`)}
  color: ${colors.balticSea};
  text-align: center;
  > div :nth-child(1) {
    ${setTypography('heading4')}
    margin-bottom: 16px;
  }
  > div :nth-child(2) {
    ${setTypography('heading5')}
  }
`;
